export const translations = {
  en: {
    heroTitle1: "Where",
    heroHand: "Posts",
    heroTitle2: ". Become",
    heroConfidence: "Sales",
    heroTitle3: ".",
    heroSubtitle:
      "You’ve shown them the story. Now show them the “buy” button. ",
    heroNote: "Reserve your spot among the first retailers.",
    cta: "I want to join",
    shopMockupTitle: "Make them take you seriously.",
    shopMockupText:
      "Stand out with a professional storefront.",
      carouselTitle1: "What's getting in your way?",
    shopMockupCTA: "Get Your Shop Now",
    customMockupTitle: "Take Back Control",
    customMockupText:
      "A complete system that organizes your orders.",
      carouselTitle2: "Losing time and energy managing orders?",
    customMockupCTA: "Get Your Shop Now",
    missionTitle: "Start Your Artisan Journey with Us!",
    missionText:
      "A space built for artisans. We listen to your needs and create solutions that serve you.",
    missionCTA: "Start Your Journey",
    joinGroupTitle: "Got challenges? We’re here to listen.",
    joinGroupText:
      "Join our WhatsApp group. Ask questions, share your challenges, your stories help shape the future of this platform.",
    joinGroupCTA: "Join WhatsApp Group",
    joinWaitingListTitle: "Join the Waiting List",
    joinWaitingListText:
      "Fill out the form below to reserve your spot and get early access!",
    home: "Home",
    joinWaitingList: "Join Waiting List",
    Credits: "Credits",
    allRightsReserved: "All rights reserved.",
    contact: "Contact",
    contactUs: "Contact Us",
    contactDescription: "For inquiries, please reach out to us at",
    copy: "Copy",
    contactOnWhatsApp: "Contact us on WhatsApp",
    whatsapp: "WhatsApp",
    seeSolution: "See solution",
    wantToJoin:"I want to join!"

  },
  fr: {
    heroTitle1: "Là où vos ",
    heroHand: "publications.",
    heroTitle2: " deviennent",
    heroConfidence: "des ventes ",
    heroTitle3: ".",
    heroSubtitle:
      "Vous leur avez raconté l’histoire. Montrez-leur maintenant le bouton « acheter ».",
    heroNote: "Réservez votre place parmi les premiers.",
    cta: "Je veux rejoindre",
    shopMockupTitle: "Faites en sorte qu’ils vous prennent au sérieux.",
    shopMockupText:
      "Distinguiez-vous avec une vitrine professionnelle.",
    shopMockupCTA: "Obtenez votre boutique",
    carouselTitle1: "Qu’est-ce qui vous freine ?",
    customMockupTitle: "Reprenez le contrôle.",
    customMockupText:
      "Un système complet qui organise vos commandes",
      carouselTitle2: "Vous perdez du temps et de l’énergie à gérer les commandes ?",

    customMockupCTA: "Obtenez votre boutique",
    missionTitle: "Commencez votre aventure artisanale avec nous !",
    missionText:
      "Un espace pensé pour les artisans. Nous écoutons vos besoins et créons des solutions qui vous servent.",
    missionCTA: "Commencer votre aventure",
    joinGroupTitle: "Des défis ? Nous sommes là pour vous écouter",
    joinGroupText:
      "Rejoignez notre groupe WhatsApp. Posez vos questions, partagez vos défis, et construisons ensemble une plateforme qui vous sert.",
    joinGroupCTA: "Rejoindre le groupe",
    joinWaitingListTitle: "Rejoignez la liste d'attente",
    joinWaitingListText:
      "Remplissez le formulaire ci-dessous pour réserver votre place et obtenir un accès anticipé !",
    home: "page d'accueil",
    joinWaitingList: "Rejoindre la Liste d'Attente",
    Credits: "Crédits",
    allRightsReserved: "Tous droits réservés.",
    contact: "Contact",
    contactUs: "Contactez-nous",
    contactDescription: "Pour toute question, veuillez nous contacter au",
    copy: "Copier",
    contactOnWhatsApp: "Contactez-nous sur WhatsApp",
    whatsapp: "WhatsApp",
    seeSolution: "Voir la solution",
    wantToJoin:"Je veux rejoindre !"


  },
  ar: {
    heroTitle1: "حيث تتحوّل",
    heroHand: "منشوراتك",
    heroTitle2:  " إلى",
    heroConfidence: " مبيعات",
    heroTitle3: ".",
    heroSubtitle:
      "لقد عرضتَ عليهم القصة، فاعرض لهم الآن زر الشراء",
    heroNote: "احجز مكانك ",
    cta: "أريد الانضمام",
    shopMockupTitle: "اجعلهم يأخذونك على محمل الجدّ",
    shopMockupText: "تميّز بواجهة متجر احترافية",
    shopMockupCTA: "احصل على متجرك الآن",
    carouselTitle1: "واش راه يعطل فيك؟",

    customMockupTitle: "استعد السيطرة",
    customMockupText: "نظام متكامل ينظم طلباتك",
    customMockupCTA: "احصل على متجرك الآن",
      carouselTitle2: "هل تضيع وقتك وجهدك في إدارة الطلبات؟",

    missionTitle: "ابدأ رحلتك الحرفية معنا",
    missionText:
      "نحن هنا لنمنح الحرفيين مساحة تُفهم فيها طبيعة الحرفة واحتياجاتها. نصغي لكم، ونبني حلولاً من أجلكم",
    missionCTA: "ابدأ رحلتك",
    joinGroupTitle: "تواجه تحديات؟ نحن هنا لنستمع إليك",
    joinGroupText:
      "انضم إلى مجموعة واتساب الخاصة بنا  اطرح أسئلتك، وشارك تحدياتك، فقصصكم تُلهمنا لبناء حلول تناسبكم",
    joinGroupCTA: "انضم إلى مجموعة ",
    joinWaitingListTitle: "انضم إلى قائمة الانتظار",
    joinWaitingListText: "املأ النموذج أدناه لحجز مكانك والحصول على وصول مبكر!",
    home: "الصفحة الرئيسية",
    joinWaitingList: "الانضمام إلى قائمة الانتظار",
    Credits: "الاعتمادات",
    allRightsReserved: "جميع الحقوق محفوظة.",
    contact: "اتصل",
    contactUs: "اتصل بنا",
    contactDescription: "للاستفسارات، يرجى التواصل معنا على",
    copy: "نسخ",
    contactOnWhatsApp: "تواصل معنا على واتساب",
    whatsapp: "واتساب",
    seeSolution: "شاهد الحل",
    wantToJoin: "أريد الانضمام",
  },
};
